import React from "react";
// react library for routing
import { useLocation, Route, Routes, Navigate, Outlet } from "react-router-dom";

import routes from "routes_auth.js";
import backgroundImage from "assets/images/auth_background.jpg";
import logo from "assets/images/logoiv.png";

function Auth() {
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  });
  
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location]);
  
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.path}
            element={<prop.component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="auth-background" style={{
        background: "#fafbfc",
        minHeight: "100vh",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1
      }}></div>
      <div className="main-content-priima" ref={mainContentRef} style={{
        zIndex: 1,
        minHeight: "100vh",
        paddingTop: 0,
        marginTop: 0
      }}>
        {/* <AuthNavbar /> */}
        {/* <div className="d-flex justify-content-center  mb-5" style={{ zIndex: 9999999}}>
        <img src={logo} style={{width: "400px"}} alt="logo_svg"/>
        </div> */}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </div>
    </>
  );
}

export default Auth;
